export default __webpack_public_path__ + "static/media/inicial_background.1d8e5e07.jpg";